// extracted by css-extract-rspack-plugin
export default {"dotsWrapper":"_d71c954a","wrapper":"_53299226","dot":"_aa6cd8aa","isVisible":"_cc39c301","small":"_eb83c22a","tiny":"_d2067b1f","isCurrent":"_17c255e6","isCurrentDark":"_2c3a1b1a"};